module.exports = __webpack_public_path__ + "media/images/restaurant/areas/near_tokyo-e74a5e1be168c40ca127106f67488b7f.png";